import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-golden-record-stage',
    templateUrl: './golden-record-stage.component.html',
    styleUrls: ['./golden-record-stage.component.css'],
    standalone: false
})
export class GoldenRecordStageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
